import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}

.imagePreview{
  width: 100%;
  max-width: 150px;
  min-width: 75px;  
}
`